import { BaseClient } from './BaseClient'

export class UserApi extends BaseClient {
  getInfo = this.createRequest({
    url: '/api/user/info',
    method: 'get',
  })
  updateFirstSession = this.createRequest({
    url: '/api/user/first-session',
    method: 'put',
  })
  getReferralBalance = this.createRequest({
    url: '/api/user/referral/balance',
  })
  changeUserLanguage = this.createRequest({
    url: `/api/user/settings/language`,
    method: 'post',
  })
  getPaymentsStatus = {
    get: (payment_id) =>
      this.createRequest({
        url: `/api/billing/payments/${payment_id}`,
        method: 'get',
      }),
  }
  getUserSessions = this.createRequest({
    url: `/api/user/sessions`,
    method: 'get',
  })
  setUserVerifyEmail = this.createRequest({
    url: `/api/user/email/verify`,
    method: 'post',
  })
  resendUserVerifyEmail = this.createRequest({
    url: `/api/user/email/resend-verify`,
    method: 'post',
  })
  restorePassword = this.createRequest({
    url: '/api/public/user/restore-password',
    method: 'post',
  })
  changeUserPassword = this.createRequest({
    url: '/api/public/user/new-password',
    method: 'post',
  })
  createRefferalLink = this.createRequest({
    url: '/api/user/referral/link',
    method: 'post',
  })
  logout = this.createRequest({
    url: '/api/logout',
    method: 'post',
    ignoreError: true,
  })
  removeUserSocial = this.createRequest({
    url: '/api/user/authmethod',
    method: 'delete',
  })
  deleteAccount = this.createRequest({
    url: '/api/user',
    method: 'delete',
  })
  setFeedback = this.createRequest({
    url: '/api/user/feedback',
    method: 'post',
  })
  getFeedback = this.createRequest({
    url: '/api/user/feedback/check',
    method: 'get',
  })

  restartFeedback = (survey) => {
    return this.createRequest({
      url: `/api/user/feedback/${survey}/restart`,
      method: 'post',
    })()
  }

  getSubscription = (token) => {
    return this.createRequest({
      url: '/api/user/subscription',
      method: 'get',
      ...(token && { token }),
    })()
  }

  loginWithSocial = (data) => {
    return this.createRequest({
      url: `/api/login`,
      method: 'post',
      data,
    })()
  }
}
